export default function NavBar() {
  return (
    <nav style={{
      background: '#fff',
      borderBottom: '2px solid #0A1740',
      padding: '14px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 50,
    }}>

      {/* LOGO */}
      <div style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 0,
      }}>
        <span style={{
          fontSize: '1.1rem',
          fontWeight: 800,
          color: '#0A1740',
          letterSpacing: '-0.3px',
          textTransform: 'uppercase',
          fontFamily: "'DM Sans', sans-serif",
        }}>
          No
        </span>
        <span style={{
          fontSize: '1.1rem',
          fontWeight: 300,
          color: '#D42B2B',
          margin: '0 2px',
          lineHeight: 1,
          fontFamily: "'DM Sans', sans-serif",
        }}>
          /
        </span>
        <span style={{
          fontSize: '1.1rem',
          fontWeight: 800,
          color: '#0A1740',
          letterSpacing: '-0.3px',
          textTransform: 'uppercase',
          fontFamily: "'DM Sans', sans-serif",
        }}>
          Dingers
        </span>
      </div>

      {/* LIVE PILL */}
      <div style={{
        background: '#D42B2B',
        color: '#fff',
        fontSize: '0.58rem',
        fontWeight: 700,
        letterSpacing: 2,
        padding: '4px 10px',
        borderRadius: 4,
        fontFamily: "'DM Mono', monospace",
        animation: 'livePulse 2s ease infinite',
      }}>
        LIVE
      </div>

    </nav>
  );
}
